<template>
  <div class="saveUser">
    <h1>个人信息完善</h1>
    <van-form @submit="onSubmit">
      <van-field
        v-model="formValue.username"
        name="姓名"
        label="姓名"
        placeholder="请填写姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="formValue.idNo"
        name="身份证号"
        label="身份证号"
        placeholder="请填写身份证号"
        :rules="[
          {
            pattern:
              /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}(\d|X|x)$/,
            message: '请输入正确的身份证号',
          },
        ]"
      />
      <van-field
        v-model="formValue.mobile"
        name="手机号"
        label="手机号"
        placeholder="请填写手机号"
        :rules="[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]"
      />
      <van-field
        v-model="formValue.password"
        name="密码"
        label="密码"
        placeholder="请输入密码"
        :rules="[{ pattern: /^.{6,}$/, message: '密码至少6位数' }]"
      />
      <p
        class="tip"
        @click="
          $router.push({ path: '/app/login', query: { id: $route.query.id } })
        "
      >
        已有账号，去登录>
      </p>
      <div style="margin: 16px">
        <van-button round block type="warning" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import wxAPI from "@/api/weixin";
export default {
  data() {
    return {
      productList: [],
      formValue: {
        username: "",
        mobile: "",
        idNo: "",
        password: "",
      },
    };
  },
  computed: {},
  created() {
    if (localStorage.h5_token) {
      this.$router.replace("/app/index");
      return;
    }
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
      this.$http({
        type: "POST",
        url: "/api/wx/saveUser",
        data: {
          recommendUserId: this.$route.query.id,
          ...this.formValue,
        },
      }).then((res) => {
        this.$router.push({
          path: "/app/login",
          query: { id: this.$route.query.id },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.saveUser .van-cell:not(:last-child)::after {
  border-bottom: 1px solid #ebedf0;
  display: block;
}
h1 {
  font-weight: 600;
  font-size: 45px;
  margin: 20px 0 20px 30px;
}
.tip {
  text-align: center;
  margin: 20px 0;
  color: #999;
}
</style>
